module.exports = __webpack_public_path__ + "static/6327-d79d74552183a6c545fb9d103c0f95f2.png";